import {
  createMultiStyleConfigHelpers,
  mergeMultiStyleConfig,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const NewParkingLotModalParts = [
  'footerContainer',
  'bodyContainer',
  'dropdownContainer',
  'dropdownLabel',
  'inputContainer',
  'inputLabel',
] as const

const helpers = createMultiStyleConfigHelpers(NewParkingLotModalParts)
export const NewParkingLotModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    bodyContainer: {
      flexDirection: 'column',
      paddingY: '0.25rem',
      paddingX: '1rem',
      gap: '1.5rem',
    },
    dropdownContainer: {
      flexDirection: 'column',
      gap: '0.25rem',
    },
    dropdownLabel: {
      ...textStyles[textStyleKeys.Body4_Bold],
    },
    inputContainer: {
      flexDirection: 'column',
      gap: '0.25rem',
    },
    inputLabel: {
      ...textStyles[textStyleKeys.Body4_Bold],
    },
    footerContainer: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '0.62rem',
    },
  },
})

export const useNewParkingLotModalStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(
    NewParkingLotModalStyle,
    props,
  ) as MultiStyleType<typeof NewParkingLotModalParts>
}
